import { render, staticRenderFns } from "./IconOrImage.vue?vue&type=template&id=8b45fad0&scoped=true&"
import script from "./IconOrImage.vue?vue&type=script&lang=js&"
export * from "./IconOrImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b45fad0",
  null
  
)

export default component.exports